import './AgeRangeFilter.css';

const LevelBadge = ({ requiredLevel, userLevel, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <span className="level-badge login-required">Login Required</span>;
  }
  if (userLevel < requiredLevel) {
    return <span className="level-badge">Level {requiredLevel}+</span>;
  }
  return null;
};

const AgeRangeFilter = ({ 
  label, 
  minValue, 
  maxValue, 
  onMinChange, 
  onMaxChange,
  onKeyDown,
  disabled = false,
  requiredLevel,
  userLevel,
  isLoggedIn
}) => {
  return (
    <div className="filter-group">
      <label>
        <span>{label}</span>
        {requiredLevel !== undefined && (
          <LevelBadge requiredLevel={requiredLevel} userLevel={userLevel} isLoggedIn={isLoggedIn} />
        )}
      </label>
      <div className="range-inputs">
        <input
          type="number"
          placeholder="Min"
          value={minValue}
          onChange={onMinChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        <input
          type="number"
          placeholder="Max"
          value={maxValue}
          onChange={onMaxChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default AgeRangeFilter;
